import { State } from "./types";

const initialState: State = {
  isFailure: false,
  isPending: false,
  isSuccessful: false,
};

export { initialState };
